import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { Add, Cancel } from "@material-ui/icons";
import { App, Events } from "app-interfaces";
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";

import { useStateValue } from "../../../config/AppContext";
import EventsClass from "../../../models/Events";
import { formatDate } from "../../../utils/time-utils";
import { AddBlockedForm, ConfirmModal, AddBlockedForm as EditBlockedForm } from "../../Modals";

const BlockedPeriods: React.FC = () => {
  const { t } = useTranslation();
  const { events, Methods } = useStateValue() as {
    events: EventsClass;
    Methods: App.Methods;
  };
  const [selected, setSelected] = React.useState<Events.IBlockedDay | null>(null);
  const [addBlock, showAddBlock] = React.useState(false);
  const [eventId, setEventIdToDelete] = React.useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name = formData.get("name");
    const start = formData.get("from");
    const end = formData.get("to");
    if (
      !name ||
      typeof name !== "string" ||
      !start ||
      typeof start !== "string" ||
      !end ||
      typeof end !== "string"
    )
      return;
    const query = {
      name: name,
      start: formatDate(new Date(start), 3),
      end: formatDate(new Date(end), 3),
      type: "BLOCKED_DAYS",
    };
    if (selected) {
      setSelected(null);
      await Methods.putEvents(query, selected.id);
      return;
    }
    showAddBlock(false);
    await Methods.postEvents(query);
  };
  const handleDelete = async () => {
    if (!eventId) return;
    await Methods.delEvents(eventId);
    await Methods.getEventsAndUpdateState();

    const targetIndex = events.blocked_days.findIndex((el) => el.id === eventId);
    events.blocked_days.splice(targetIndex, 1);
    return setEventIdToDelete(null);
  };
  if (events && events.blocked_days && events.blocked_days.length > 0) {
    return (
      <>
        <Typography variant="subtitle1">{t("Blocked periods")}</Typography>
        <Paper>
          {events.blocked_days.map((el) =>
            el.id ? (
              <Grid container spacing={2} key={el.id} component="section">
                <Grid item xs={6}>
                  <Typography variant="body1" onClick={() => setSelected(el)} noWrap>
                    {el.name}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" component="span" onClick={() => setSelected(el)}>
                    {el.start ? format(new Date(el.start), "dd MMM") : ""}
                    {" - "}
                    {el.end ? format(new Date(el.end), "dd MMM") : ""}
                  </Typography>
                  <Cancel onClick={() => setEventIdToDelete(el.id)} />
                </Grid>
              </Grid>
            ) : (
              <></>
            )
          )}
        </Paper>
        <Button fullWidth variant="contained" color="primary" onClick={() => showAddBlock(true)}>
          {t("Add more")} <Add />
        </Button>
        <AddBlockedForm
          show={addBlock}
          onHide={() => showAddBlock(false)}
          onSubmit={handleSubmit}
        />
        <EditBlockedForm
          show={!!selected}
          onHide={() => setSelected(null)}
          onSubmit={handleSubmit}
          startDate={selected?.start}
          endDate={selected?.end}
          name={selected?.name}
        />
        <ConfirmModal
          show={!!eventId}
          onHide={() => setEventIdToDelete(null)}
          onSubmit={handleDelete}
          title={t("Confirm Delete")}
          message={t("Are you sure you want to remove this entry?")}
        />
      </>
    );
  }
  return (
    <>
      <Typography variant="subtitle1">{t("Blocked periods")}</Typography>
      <Button fullWidth variant="contained" color="primary" onClick={() => showAddBlock(true)}>
        {t("Add more")}
        <Add />
      </Button>
      <AddBlockedForm show={addBlock} onHide={() => showAddBlock(false)} onSubmit={handleSubmit} />
    </>
  );
};

export default BlockedPeriods;
